import {Injectable} from '@angular/core';
import {Data} from '../../../types/tunings';
import {TrialStatus} from '../../../services/site-details.service';
import {sitesStore} from './sites.store';
import {setProps} from '@ngneat/elf';
import {SiteSearchEntryDto, SiteSearchResultDto} from '../../../../userway/sdk/UserWayApiClient';

@Injectable({providedIn: 'root'})
export class SitesManager {
  public setLoading(value: boolean) {
    sitesStore.update(setProps({isLoading: value}));
  }
  public setActiveSites(sitesData: SiteSearchResultDto) {
    sitesStore.update(setProps({activeSites: sitesData}));
  }
  public setActivePdfSites(sitesData: SiteSearchResultDto) {
    sitesStore.update(setProps({activePdfSites: sitesData}));
  }
  public setDeletedSites(sitesData: SiteSearchResultDto) {
    sitesStore.update(setProps({deletedSites: sitesData}));
  }
  public setPendingSites(sitesData: SiteSearchResultDto) {
    sitesStore.update(setProps({pendingSites: sitesData}));
  }
  public setSiteLoading(value: boolean) {
    sitesStore.update(setProps({currentSiteIsLoading: value}));
  }

  public setCurrentSite(site: SiteSearchEntryDto) {
    sitesStore.update(setProps({currentSite: site}));
  }

  public setSitesCount(count: number) {
    sitesStore.update(setProps({sitesCount: count}));
  }

  public setSiteTunings(tunings: Data) {
    sitesStore.update(setProps({siteTunings: tunings}));
  }

  public setTrial(trial: TrialStatus) {
    sitesStore.update(setProps({trial}));
  }

  public setSiteNotFound(notFound: boolean) {
    sitesStore.update(setProps({siteNotFound: notFound}));
  }

  public resetSiteData() {
    this.setCurrentSite(null);
    this.setSiteTunings(null);
  }

  public reset() {
    sitesStore.reset();
  }
}
